@if (summary(); as summary) {
  <bx-card>
    <bx-card-header [divider]="false" [title]="'deviceDetails.heatingDisruption.title' | translate"></bx-card-header>

    <div class="gap-lg pt-2xl pb-3xl px-3xl flex w-full flex-col items-start">
      <!-- innerHTML so the translation can carry <b> around the words to stress; the pills below cannot, bx-badge prints its label as text. -->
      @if (summary.current; as current) {
        <p
          class="text-text-primary-900 text-sm [&_b]:font-semibold"
          [innerHTML]="'deviceDetails.heatingDisruption.current' | translate: { since: formatDateAtTime(current.since) }"
        ></p>
      } @else {
        <p class="text-text-primary-900 text-sm [&_b]:font-semibold" [innerHTML]="'deviceDetails.heatingDisruption.none' | translate"></p>
      }

      @if (summary.last; as last) {
        <bx-badge
          size="lg"
          type="pill-color"
          color="gray"
          iconType="dot"
          [label]="'deviceDetails.heatingDisruption.last' | translate: { from: formatDateAtTime(last.from), to: formatDateAtTime(last.to) }"
        ></bx-badge>
      }

      @if (summary.all; as all) {
        @let allKey = all.count === 1 ? 'deviceDetails.heatingDisruption.all.one' : 'deviceDetails.heatingDisruption.all';
        <bx-badge
          size="lg"
          type="pill-color"
          color="gray"
          iconType="dot"
          [label]="allKey | translate: { count: all.count, from: formatDateAtTime(all.from), to: formatDateAtTime(all.to) }"
        ></bx-badge>
      }
    </div>
  </bx-card>
}
